import * as React from 'react';
import cx from 'classnames';

import { ArrowLeftIcon } from 'src/icons';
import { Input, SubmitButton } from 'src/widgets';
import { getErrorMessageFromResponse } from 'src/common/utils/getErrorMessageFromResponse';

import styles from './ExtraPostUpload.scss';
import { InstagramStoryUploadPage } from '../InstagramStoryUploadPage/InstagramStoryUploadPage';
import { IPublisher } from 'src/common/models/publisher';
import { IPostProject } from 'src/common/models/postProject';

const { useState } = React;

export interface IExtraPostUploadProps {
  className?: string;
  extraPostUploadUrl: string;
  onBack: () => void;
  onContactSupport: () => void;
  project: IPostProject;
  publisher: IPublisher;
  uceAPIEndpoint: string;
}

const uploadExtraPost = async (extraPostUploadUrl: string, liveUploadLink: string): Promise<any> => {
  const resp = await fetch(extraPostUploadUrl, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    credentials: 'include',
    body: JSON.stringify({ live_upload_link: liveUploadLink }),
  });

  const json = await resp.json();

  if (json.status && json.status.code === 204) {
    return json.data;
  } else {
    throw new Error(getErrorMessageFromResponse(json));
  }
};
const uploadExtraInstagramStories = async (extraPostUploadUrl: string, storyIds: string[]): Promise<any> => {
  const resp = await fetch(extraPostUploadUrl, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    credentials: 'include',
    body: JSON.stringify({ live_story_ids: storyIds }),
  });

  const json = await resp.json();

  if (json.status && json.status.code === 204) {
    return;
  } else {
    throw new Error(getErrorMessageFromResponse(json));
  }
};

/**
 * @type {React.FunctionComponent}
 */
export const ExtraPostUpload: React.FunctionComponent<IExtraPostUploadProps> = (props) => {
  const {
    className,
    extraPostUploadUrl,
    onBack,
    onContactSupport,
    project,
    publisher,
    uceAPIEndpoint
  } = props;

  const [liveContentLink, setLiveContentLink] = useState('');
  const [postLinkErrorMsg, setPostLinkErrorMsg] = useState('');
  const [storyLinkErrorMsg, setStoryLinkErrorMsg] = useState('');

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChangeLiveContentLink = (value: string) => {
    setLiveContentLink(value);
    setPostLinkErrorMsg('');
  };
  const handleClickBack = () => {
    onBack();
  };

  const handleClickSubmitPost = async () => {
    try {
      setIsSubmitting(true);
      setPostLinkErrorMsg('');
      await uploadExtraPost(extraPostUploadUrl, liveContentLink);

      handleClickBack();
    } catch (err) {
      console.error(err);

      setIsSubmitting(false);
      setPostLinkErrorMsg(err.message);
    }
  };
  const handleClickSaveStory = async (liveStoryIds: string[]) => {
    try {
      setIsSubmitting(true);
      setStoryLinkErrorMsg('');
      await uploadExtraInstagramStories(extraPostUploadUrl, liveStoryIds);
      handleClickBack();
    } catch (err) {
      setIsSubmitting(false);
      setStoryLinkErrorMsg(err.message);
      throw new Error(err);
    }
  };


  return (
    <div className={cx(styles.ExtraPostUpload, className)}>
      <div className={styles.top}>
        <div className={styles.backButton} onClick={handleClickBack}>
          <ArrowLeftIcon size={12} />
          Back
        </div>
      </div>

      <div className={styles.header}>Add all post types except Instagram Stories here</div>

      <div className={styles.form}>
        <div className={styles.group}>
          <label className={styles.label}>Link to Live content</label>
          <Input placeholder='Enter link...' value={liveContentLink} onChange={handleChangeLiveContentLink} />
        </div>

        <SubmitButton
          label='Submit Post'
          submittingLabel='Submitting...'
          isSubmitting={isSubmitting}
          onClick={handleClickSubmitPost}
          disabled={!liveContentLink || isSubmitting}
          iconSide='right'
        />

        {postLinkErrorMsg && <div className={styles.error}>{postLinkErrorMsg}</div>}
      </div>

      <div className={styles.divider}></div>

      <div className={styles.uploadPost}>
        <InstagramStoryUploadPage
          modalOnly={true}
          publisher={publisher}
          project={project}
          apiEndpoint={uceAPIEndpoint}
          onSubmitStories={handleClickSaveStory}
          disabled={isSubmitting}
          onContactSupport={onContactSupport}
        />
        {storyLinkErrorMsg && <div className={styles.error}>{storyLinkErrorMsg}</div>}
      </div>
    </div>
  );
};
